/**
 * Слайс приложения: минимальное состояние shell до профиля и опроса.
 * @module store/app
 */

import type { RootAction } from '../store.types';
import { setMeta } from '../store.utils';

import { APP_PING, type AppState } from './types';

export { APP_PING, type AppAction, type AppState } from './types';

export const initialAppState: AppState = {
  status: setMeta.initial(),
};

/**
 * Редьюсер слайса app: неизвестные корневые экшены игнорируются.
 *
 * @param {AppState} state — текущее состояние слайса
 * @param {RootAction} action — экшен из корневого union-типа
 * @returns {AppState}
 */
export function appReducer(state: AppState, action: RootAction): AppState {
  if (action.type === APP_PING) {
    return state;
  }

  return state;
}
